<div class="col-xs-12">
  <div class="row">
    <div style="height:50px;cursor: pointer;" class="col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center" id="patientDashboardTop" (click)="toggleTopBar('patientDashboardTop')">
      <label style=" cursor: pointer;color:#FFFFFF;margin-top:5px"><i class="fa fa-user" style="font-size: 30px;"></i> Appointment Statistics</label>
    </div>
    <div style="height:50px;cursor: pointer;" class="col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center" id="doctorDashboardTop" (click)="toggleTopBar('doctorDashboardTop');getAllDoctors();activateDoctorVerificationPage();">
      <label style=" cursor: pointer;color:#FFFFFF;margin-top:5px"><i class="fa fa-user-md" style="font-size: 30px;">
      <span data-toggle="tool-tip" title="Pending for review" style="vertical-align: text-top;font-size: 16px;color: black;font-weight: bolder;background-color: greenyellow;border-radius: 12px;padding: 4px;">{{doctorVerificationPending.length}}</span></i> Doctor Verification</label>
  </div>
  <div style="height:50px;cursor: pointer;" class="col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center" id="allDoctorsTop" (click)="toggleTopBar('allDoctorsTop')">
      <label style=" cursor: pointer;color:#FFFFFF;margin-top:5px"><i class="fa fa-users" style="font-size: 30px;"></i> All Doctors</label>
  </div>
    <div style="height:50px;cursor: pointer;" class="col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center" id="paymentDashboardTop" (click)="toggleTopBar('paymentDashboardTop')">
      <label style=" cursor: pointer;color:#FFFFFF;margin-top:5px"><i class="fa fa-paypal" style="font-size: 30px;"></i> Export for Billing</label>
    </div>
  </div>
</div>
<!-- start : appointment page-->
<div *ngIf="this.selectedTab=='patientDashboardTop'">
<div *ngIf="!showAppointmnetPage">
  <!-- start : filter selection -->
  <div class="tile-progress bg-white text-left">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <label style="margin-top:10px">Select Date Range</label>
        <ngx-mat-drp  (selectedDateRangeChanged)="updateRange($event)" [options]="options" #dateRangePicker>
        </ngx-mat-drp>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <label style="margin-top:10px">Select Doctor</label>
        <!--<select [(ngModel)]="doctorId" (change)="getAppointmentDashboardData()" class="form-select form-select-sm">
          <option *ngFor="let itr of telecaredoctors" [ngValue]="itr.userId" *ngIf="itr.firstName!=null && itr.lastName!=null">{{itr.firstName}} {{itr.lastName}}</option>
        </select> -->
        <ng-select [items]="telecaredoctors" name="telecaredoctors" bindLabel="firstName"
        [clearable]="true" [searchable]="true" bindValue="userId" [(ngModel)]="doctorId" placeholder="Select doctor">
    </ng-select>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <button class="btn btn-primary" (click)="getAppointmentDashboardData()" style="margin-top: 36px;">Get Statistics</button>
      </div>
    </div>
  </div>
<!-- end : filter selection -->
<!-- start : total statistics -->
  <div>
    <div class="panel">
        <div class="panel-heading">
            <div style="margin: 10px;color:#2d5aa0;font-size:14px;">
              <span *ngIf="selectedTab=='patientDashboardTop'">Appointment Statistics</span> 
              <span *ngIf="selectedTab=='doctorDashboardTop'">Doctor Statistics</span> 
              <span *ngIf="selectedTab=='paymentDashboardTop'">Payment Statistics</span> 
              <button class="btn btn-sm btn-success pull-right" (click)="exportAppointmentDateWiseSplit()" data-toggle="tool-tip" title="Export excel"><i class="fa fa-file-excel-o"></i></button>
            </div>
            <div class="infobox-container" style="margin-bottom: 25px;margin-top: 25px;">
              <div class="infobox infobox-purple2">
                <div class="infobox-icon">
                    <i class="ace-icon fa fa-database"></i>
                </div>
                <div class="infobox-data">
                    <span class="infobox-data-number">{{totalRegisteredPatientsCount}}</span>
                    <div class="infobox-content"> Total Patients Registered </div>
                </div>
              </div>
                <div class="infobox infobox-blue">
                    <div class="infobox-icon">
                        <i class="ace-icon fa fa-calendar"></i>
                    </div>
                    <div class="infobox-data">
                        <span class="infobox-data-number">{{appointmentDashboardData.appointmentScheduledCount}}</span>
                        <div class="infobox-content"> Total Booked Appointments </div>
                    </div>
                </div>
                <div class="infobox infobox-orange">
                    <div class="infobox-icon">
                        <i class="ace-icon fa fa-clock-o"></i>
                    </div>
                    <div class="infobox-data">
                        <span class="infobox-data-number">{{appointmentDashboardData.appointmentRescheduledCount}}</span>
                        <div class="infobox-content"> Total Rescheduled Appointments </div>
                    </div>
                </div>
                <div class="infobox infobox-green" >
                    <div class="infobox-icon">
                        <i class="ace-icon fa fa-file-text-o"></i>
                    </div>
                    <div class="infobox-data">
                        <span class="infobox-data-number">{{appointmentDashboardData.appointmentConsultationCount}}</span>
                        <div class="infobox-content"> Total Consultations </div>
                    </div>
                </div>
                <div class="infobox infobox-red">
                    <div class="infobox-icon">
                        <i class="ace-icon fa fa-remove"></i>
                    </div>
                    <div class="infobox-data">
                        <span class="infobox-data-number">{{appointmentDashboardData.appointmentCancelledCount}}</span>
                        <div class="infobox-content">Total Cancelled Appoinments </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end : total statistics -->
<!-- start : datewise table -->
<div>
    <div class="panel">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
              <tr>
                <td>
                  #
                </td>
                <td>
                  Date
                </td>
                <!--<td>
                  Patients Registered
                </td>-->
                <td>
                  Appointments Booked
                </td>
                <td>
                  Appointments Rescheduled
                </td>
                <td>
                  Consultations
                </td>
                <td>
                  Appoinments Cancelled
                </td>
                <td>
                  Payment Cancelled
                </td>
                <td></td>
              </tr>
          </thead>
          <tbody>
              <tr *ngIf="appointmentDashboardData==null || appointmentDashboardData.appointmentDatewiseList==null || appointmentDashboardData.appointmentDatewiseList.length==0">
                <td colspan="8" class="text-center">No record(s) found</td>
              </tr>
              <tr *ngFor="let itr of appointmentDashboardData.appointmentDatewiseList | paginate: { itemsPerPage: 10, currentPage: p };let i=index">
                <td>{{p==null||p=='undefined'?i+1:i+1+(10*(p-1))}}</td>
                <td>{{getFormattedDate(itr.date)}}</td>
                <!--<td>{{itr.registeredPatients}}</td>-->
                <td>{{itr.scheduled}}</td>
                <td>{{itr.rescheduled}}</td>
                <td>{{itr.completed}}</td>
                <td>{{itr.cancelled}}</td>
                <td>{{itr.payment_cancelled}}</td>
                <td><button class="btn btn-sm btn-primary" (click)="showAppointmnetPage=true;showAppointDetailsByDate(itr.date)">View Details</button></td>
              </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="8" class="text-center" >
                <pagination-controls (pageChange)="p = $event" *ngIf="appointmentDashboardData!=null && appointmentDashboardData.appointmentDatewiseList!=null && appointmentDashboardData.appointmentDatewiseList.length>0"></pagination-controls>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
</div>
<!-- end : datewise table -->
</div>
<div class="col-xs-12" *ngIf="showAppointmnetPage">
        <div class="tile-progress bg-white text-left col-xs-12">
          <div class="col-xs-6">
          <label>Payment Status</label>
          <select [(ngModel)]="selectedPaymentFilter" class="form-select form-select-sm" (change)="filterTransactionsByPaymentStatus(selectedPaymentFilter)">
            <option value="ALL">All</option>
            <option value="PAYMENT_INITIATED">Initiated</option>
            <option value="PAYMENT_SUCCESS">Success</option>
            <option value="PAYMENT_FAILED">Failed</option>
            <!--<option value="REFUND_INITIATED">Refund Initiated</option>
            <option value="REFUND_COMPLETED">Refund Completed</option>
            <option value="REFUND_FAILED">Refund Failed</option>-->
          </select>
        </div>
        </div>
        <div class="card-header">
          Appointment Details 
          <span class="pull-right"><button class="btn btn-sm btn-warning" (click)="showAppointmnetPage=false"><i class="fa fa-arrow-left">&nbsp;Back</i></button>
          <button style="margin-left: 10px;" class="btn btn-sm btn-success " (click)="exportAppointmentDetails()" data-toggle="tool-tip" title="Export excel"><i class="fa fa-file-excel-o"></i></button></span>
        </div>
        <ul style="list-style-type: none;margin: 0;padding: 0;overflow: hidden;width:100%;border-bottom: 1px solid #CCC;padding-top: 15px;
        background: #FFF;
        margin-bottom: 15px;">
          <li id="all" (click)="filterTransactions('ALL')"
            style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
            All Appointments</li>
          <li id="booked" (click)="filterTransactions('SCHEDULED')"
            style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
            Booked Appointments</li>
          <li id="rescheduled" (click)="filterTransactions('RESCHEDULED')"
            style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
            Rescheduled Appointments</li>
          <li id="completed" (click)="filterTransactions('COMPLETED')"
            style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
            Completed Consultations</li>
          <li id="cancelled" (click)="filterTransactions('CANCELLED')"
            style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
            Cancelled Appointments</li>
        </ul>
        <div class="col-xs-12 text-center" *ngIf="filteredAppointmentDetails==null || filteredAppointmentDetails.length==0"
          style="background: #FFF;padding: 10px;margin-bottom: 20px;">
          No record found
        </div>
        <div class="card-body" style="background: #FFF;padding-top: 10px;margin-top: 20px;"
          *ngFor="let filteredAppointmentDetailsItr of filteredAppointmentDetails">
          <div style="border-color: #FFF;">
            <div *ngIf="filteredAppointmentDetails!=null && filteredAppointmentDetails.length>0">
              <div class="panel" [ngClass]="{'booked-panel-border': filteredAppointmentDetailsItr.appointmentStatus=='SCHEDULED',
              'rescheduled-panel-border': filteredAppointmentDetailsItr.appointmentStatus=='RESCHEDULED',
              'completed-panel-border': filteredAppointmentDetailsItr.appointmentStatus=='COMPLETED',
              'cancelled-panel-border': (filteredAppointmentDetailsItr.appointmentStatus!='SCHEDULED'&& filteredAppointmentDetailsItr.appointmentStatus!='RESCHEDULED' && filteredAppointmentDetailsItr.appointmentStatus!='COMPLETED')}">

                <div class="panel-heading col-xs-12" [ngClass]="{'booked-panel-border-bottom': filteredAppointmentDetailsItr.appointmentStatus=='SCHEDULED',
                'rescheduled-panel-border-bottom': filteredAppointmentDetailsItr.appointmentStatus=='RESCHEDULED',
                'completed-panel-border-bottom': filteredAppointmentDetailsItr.appointmentStatus=='COMPLETED',
                'cancelled-panel-border-bottom': (filteredAppointmentDetailsItr.appointmentStatus!='SCHEDULED' && filteredAppointmentDetailsItr.appointmentStatus!='RESCHEDULED' && filteredAppointmentDetailsItr.appointmentStatus!='COMPLETED')}">

                  <div class="col-xs-12 col-md-6">Appointment Status :&nbsp;<span [ngClass]="{'booked-panel-flag': filteredAppointmentDetailsItr.appointmentStatus=='SCHEDULED',
                  'rescheduled-panel-flag': filteredAppointmentDetailsItr.appointmentStatus=='RESCHEDULED',
                  'completed-panel-flag': filteredAppointmentDetailsItr.appointmentStatus=='COMPLETED',
                  'cancelled-panel-flag': (filteredAppointmentDetailsItr.appointmentStatus!='COMPLETED' && filteredAppointmentDetailsItr.appointmentStatus!='RESCHEDULED' && filteredAppointmentDetailsItr.appointmentStatus!='SCHEDULED')}">{{getValueByKey[filteredAppointmentDetailsItr.appointmentStatus]}}</span>
                  &nbsp;<span *ngIf="filteredAppointmentDetailsItr.isRescheduled==true" [ngClass]="{'rescheduled-panel-flag': filteredAppointmentDetailsItr.isRescheduled==true}">{{getValueByKey['RESCHEDULED']}}</span>
                </div>

                  <div class="col-xs-12 col-md-6 text-right">Payment Status :&nbsp;<span [ngClass]="{'paymentsuccess-panel-flag': filteredAppointmentDetailsItr.paymentStatus=='PAYMENT_SUCCESS',
                  'paymentinitiated-panel-flag': filteredAppointmentDetailsItr.paymentStatus=='PAYMENT_INITIATED',
                  'paymentfailed-panel-flag': filteredAppointmentDetailsItr.paymentStatus=='PAYMENT_FAILED',
                  'fullrefunded-panel-flag': filteredAppointmentDetailsItr.refundStatus=='FULL REFUNDED',
                  'refundinprogress-panel-flag': filteredAppointmentDetailsItr.refundStatus=='REFUND IN PROGRESS',
                  'refundsettlementinprogress-panel-flag': filteredAppointmentDetailsItr.refundStatus=='SETTLEMENT IN PROGRESS'}"> {{(getValueByKey.refundStatus!=null && getValueByKey.refundStatus.length>0)?'[' + getValueByKey.refundStatus + ']' : ''}} &nbsp;{{filteredAppointmentDetailsItr.paymentStatus=='NA'?'NA':getValueByKey[filteredAppointmentDetailsItr.paymentStatus]}} </span></div>

                  <div class="col-xs-12 col-md-6" >Appointment Date :&nbsp;{{getFormattedDateTime(filteredAppointmentDetailsItr.appointmentCeatedDate)}}</div>
                  <div class="col-xs-12 col-md-6 text-right">Transaction Id :&nbsp;{{filteredAppointmentDetailsItr.transactionId}}</div>
                  <div class="col-xs-12 col-md-6" ></div>
                  <div class="col-xs-12 col-md-6 text-right">Payment Gateway :&nbsp;
                    <span *ngIf="(filteredAppointmentDetailsItr.mercantile.toUpperCase()=='RAZORPAY' || filteredAppointmentDetailsItr.mercantile.toUpperCase()=='PAYUMONEY');else else_content">
                      <span class="badge" style="border-radius: 4px;background:#03299c;font-style: italic;font-weight: normal;" *ngIf="filteredAppointmentDetailsItr.mercantile.toUpperCase()=='RAZORPAY'">{{filteredAppointmentDetailsItr.mercantile}}</span>
                      <span class="badge" style="border-radius: 4px;background:#F4A460;font-style: italic;font-weight: normal;" *ngIf="filteredAppointmentDetailsItr.mercantile.toUpperCase()=='PAYUMONEY'">{{filteredAppointmentDetailsItr.mercantile}}</span>
                      </span>
                      <ng-template #else_content>NA</ng-template>
                  </div>
              </div>
              <div class="panel-body">
                <div class="col-xs-6" >Patient Id :&nbsp;{{filteredAppointmentDetailsItr.patientId}}</div>
                <div class="col-xs-6" >Slot Time :&nbsp;{{getFormattedDate(filteredAppointmentDetailsItr.slotStartTime)}} &nbsp; [{{getFormattedTime(filteredAppointmentDetailsItr.slotStartTime)}} - {{getFormattedTime(filteredAppointmentDetailsItr.slotEndTime)}}]</div>
                <div class="col-xs-6" >
                  <span *ngIf="loadingDoctors"><i class="fa fa-refresh fa-spin"></i>&nbsp;fetching...</span>
                  <span *ngIf="!loadingDoctors">Doctor Name :&nbsp;{{filteredAppointmentDetailsItr.doctorName}}</span></div>
                <div class="col-xs-6" >Consultation Fee :&nbsp;{{filteredAppointmentDetailsItr.consultaionFee}}</div>
                <div class="col-xs-6" >
                  <span *ngIf="loadingDoctors"><i class="fa fa-refresh fa-spin"></i>&nbsp;fetching...</span>
                  <span *ngIf="!loadingDoctors">Doctor Specialization :&nbsp;{{filteredAppointmentDetailsItr.doctorSpecialization}}</span>
              </div>
              <div *ngIf="filteredAppointmentDetailsItr.appointmentStatus=='CANCELLED'" class="col-xs-6">
                Cancelled By :&nbsp;{{filteredAppointmentDetailsItr.appointmentCancelledBy}}
              </div>
            </div>
          </div>
        </div>
    </div>
        </div>
</div>
</div>
<!-- end : appointment page-->
<!-- start : doctor verification page-->
<div *ngIf="selectedTab=='doctorDashboardTop'">
<div class="col-xs-12 table-responsive">
  <table class="table table-striped" style="width: 90%;margin: auto;margin-top: 2%;border: 2px solid #6FB3E0;">
    <thead style="background: #6FB3E0;border: 1px solid #6FB3E0;border-bottom: 2.5px solid #6FB3E0;" >
      <tr ><th colspan="3" class="text-center" style="color: white;">Doctor Information</th></tr>
    </thead>
    <tbody *ngIf="doctorVerificationPending==null || doctorVerificationPending.length==0">
      <tr><td colspan="3" class="text-center">No record(s) to display</td></tr>
    </tbody>
    <tbody *ngIf="doctorVerificationPending!=null && doctorVerificationPending.length>0">
    <tr>
      <td>Registered On</td>
      <td style="padding-left: 400px;">{{getFormattedDate(doctorVerificationPending[0].created)}}</td>
      <td style="padding-left: 400px;"></td>
    </tr>
    <tr>
      <td>Medical Reg No *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].regNo}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].regNo!=null && doctorVerificationPending[0].regNo!='null' && doctorVerificationPending[0].regNo.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].regNo==null || doctorVerificationPending[0].regNo=='null' || doctorVerificationPending[0].regNo.length==0"></i></td>
    </tr>
    <tr>
      <td>GST Number</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].opd.gstNumber}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].opd!=null && doctorVerificationPending[0].opd.gstNumber!=null && doctorVerificationPending[0].opd.gstNumber.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].opd==null || doctorVerificationPending[0].opd.gstNumber==null || doctorVerificationPending[0].opd.gstNumber.length==0"></i></td>
    </tr>
    <tr>
      <td>Mobile *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].mobileNumber}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].mobileNumber!=null && doctorVerificationPending[0].mobileNumber!='null' && doctorVerificationPending[0].mobileNumber.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].mobileNumber==null || doctorVerificationPending[0].mobileNumber=='null' || doctorVerificationPending[0].mobileNumber.length==0"></i></td>
    </tr>
    <tr>
      <td>Email *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].email}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].email!=null && doctorVerificationPending[0].email!='null' && doctorVerificationPending[0].email.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].email==null || doctorVerificationPending[0].email=='null' || doctorVerificationPending[0].email.length==0"></i></td>
    </tr>
    <tr>
      <td>First Name *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].firstName}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].firstName!=null && doctorVerificationPending[0].firstName!='null' && doctorVerificationPending[0].firstName.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].firstName==null || doctorVerificationPending[0].firstName=='null' || doctorVerificationPending[0].firstName.length==0"></i></td>
    </tr>
    <tr>
      <td>Last Name *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].lastName}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].lastName!=null && doctorVerificationPending[0].lastName!='null' && doctorVerificationPending[0].lastName.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].lastName==null || doctorVerificationPending[0].lastName=='null' || doctorVerificationPending[0].lastName.length==0"></i></td>
    </tr>
    <tr>
      <td>Consultation Fee (Rs.)</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].opd.fee}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].opd!=null && doctorVerificationPending[0].opd.fee!=null"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].opd==null || doctorVerificationPending[0].opd.fee==null"></i></td>
    </tr>
    <tr>
      <td>Followup Consultation Fee (Rs.)</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].opd.followupFee}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].opd!=null && doctorVerificationPending[0].opd.followupFee!=null"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].opd==null || doctorVerificationPending[0].opd.followupFee==null"></i></td>
    </tr>
    <tr>
      <td>Specialization *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].specialization}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].specialization!=null && doctorVerificationPending[0].specialization!='null' && doctorVerificationPending[0].specialization.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].specialization==null || doctorVerificationPending[0].specialization =='null' || doctorVerificationPending[0].specialization.length==0"></i></td>
    </tr>
    <tr>
      <td>Degree *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].degree}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].degree!=null && doctorVerificationPending[0].degree!='null' && doctorVerificationPending[0].degree.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].degree==null || doctorVerificationPending[0].degree=='null' || doctorVerificationPending[0].degree.length==0"></i></td>
    </tr>
    <tr>
      <td>Experience (Years)</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].yearsOfExperience}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].yearsOfExperience!=null && doctorVerificationPending[0].yearsOfExperience!='null'"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].yearsOfExperience==null || doctorVerificationPending[0].yearsOfExperience=='null'"></i></td>
    </tr>
    <tr>
      <td>Clinic / Hospital Name</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].hospitalName}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].hospitalName!=null && doctorVerificationPending[0].hospitalName!='null' && doctorVerificationPending[0].hospitalName.length>0"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].hospitalName==null || doctorVerificationPending[0].hospitalName =='null' || doctorVerificationPending[0].hospitalName.length==0"></i></td>
    </tr>
    <tr>
      <td>Clinic / Hospital City *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].address.city}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].address.city!=null && doctorVerificationPending[0].address.city!='null'"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].address == null || doctorVerificationPending[0].address.city==null || doctorVerificationPending[0].address.city=='null' "></i></td>
    </tr>
    <tr>
      <td>Clinic / Hospital State *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].address.state}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].address.state!=null && doctorVerificationPending[0].address.state!='null' "></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].address == null || doctorVerificationPending[0].address.state==null || doctorVerificationPending[0].address.state=='null' "></i></td>
    </tr>
    <tr>
      <td>Clinic / Hospital Pincode *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].address.zipcode}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].address.zipcode!=null && doctorVerificationPending[0].address.zipcode!='null'"></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].address == null || doctorVerificationPending[0].address.zipcode==null || doctorVerificationPending[0].address.zipcode=='null'"></i></td>
    </tr>
    <tr>
      <td>Age (Years) *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].age}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].age!=null && doctorVerificationPending[0].age!='null' "></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].age==null || doctorVerificationPending[0].age=='null'"></i></td>
    </tr>
    <tr>
      <td>Gender *</td>
      <td style="padding-left: 400px;">{{doctorVerificationPending[0].gender!=null ? (doctorVerificationPending[0].gender.charAt(0).toUpperCase()+doctorVerificationPending[0].gender.substring(1).toLowerCase()):''}}</td>
      <td style="padding-left: 400px;"><i class="fa fa-check-circle" style="color:green;font-size: 20px" *ngIf="doctorVerificationPending[0].gender!=null && doctorVerificationPending[0].gender!='null' "></i>
        <i class="fa fa-times-circle" style="color:red;font-size: 20px"*ngIf="doctorVerificationPending[0].gender==null || doctorVerificationPending[0].gender=='null'"></i></td>
    </tr>
    <tr >
      <td>Doctor Bank Details</td>
      <td colspan="2">
        <div *ngIf="loadingDoctorBankDetails" style="padding-left: 380px;"><i class="fa fa-refresh fa-spin"></i>&nbsp;Loading records . . .</div>
      <div *ngIf="doctorBankDetails==null && !loadingDoctorBankDetails" style="padding-left: 380px;">Not Available</div>
      <div class="table-responsive" style="width:1000px" *ngIf="doctorBankDetails!=null && !loadingDoctorBankDetails">
      <table class="table table-bordered"><tr>
        <td><span style="font-weight: bold;">Bank Name</span> : {{doctorBankDetails.bankName==null?'NA':doctorBankDetails.bankName}}</td>
        <td><span style="font-weight: bold;">Branch Name</span> : {{doctorBankDetails.branchName==null?'NA':doctorBankDetails.branchName}}</td>
        </tr>
        <tr>
        <td><span style="font-weight: bold;">Account Number</span> : {{doctorBankDetails.accountNumber==null?'NA':doctorBankDetails.accountNumber}}</td>
        <td><span style="font-weight: bold;">IFSC Code</span> : {{doctorBankDetails.ifsc==null?'NA':doctorBankDetails.ifsc}}</td>
      </tr></table>
      </div>
      </td>
    </tr>
    <tr >
      <td>Doctor Certificates *</td>
      <td colspan="2">
        <div *ngIf="loadingUploadedDoctorDocList" style="padding-left: 380px;"><i class="fa fa-refresh fa-spin"></i>&nbsp;Loading records . . .</div>
      <div *ngIf="(uploadedDoctorDocList==null || uploadedDoctorDocList.length==0) && !loadingUploadedDoctorDocList" style="padding-left: 380px;">Not Available</div>
      <div class="table-responsive" style="width:1000px" *ngIf="uploadedDoctorDocList!=null && uploadedDoctorDocList.length>0 && !loadingUploadedDoctorDocList">
      <table class="table"><tr>
      <td *ngFor="let documentItr of uploadedDoctorDocList" style="border: 1px solid lightgrey"><table style="border: 1px solid lightgrey" class="table table-striped">
        <tr><td colspan="2" class="text-center">{{documentItr.recordName +'.'+ documentItr.extension }}</td></tr>
        <tr><td colspan="2" class="text-center">
          <i class="fa fa-file-pdf-o" *ngIf = "documentItr.extension.toUpperCase()=='PDF'" style="color: indianred; font-size: 60px;"></i>
          <i class="fa fa-picture-o" *ngIf = "documentItr.extension.toUpperCase()=='JPG' || documentItr.extension.toUpperCase()=='JPEG' || documentItr.extension.toUpperCase()=='PNG'" style="color: cadetblue; font-size: 60px;"></i>
          <i class="fa fa-file" *ngIf = "documentItr.extension.toUpperCase()!='PDF' && documentItr.extension.toUpperCase()!='JPG' && documentItr.extension.toUpperCase()!='JPEG' && documentItr.extension.toUpperCase()!='PNG'" style="color: cornflowerblue; font-size: 60px;"></i>
          
        </td></tr>
        <tr><td style="padding-left: 0px;padding-right: 0px;"><button class="btn btn-sm pull-right" style="background: #5DADE2;color: white;"(click)="downloadBase64FileByUrlAndName(documentItr.recordPath,documentItr.recordName+'.'+documentItr.extension)">Download</button></td><td ><button style="color: white;background: #FF8C33;" class="btn btn-sm" (click)="viewDocument(documentItr.recordPath,documentItr.extension)">View</button></td></tr>
        </table>
      </td>
      </tr>
      </table>
      </div>
      </td>
    </tr>
    </tbody>
    <tfoot *ngIf="doctorVerificationPending!=null && doctorVerificationPending.length>0">
      <tr><td colspan="3">
        <!--<div>
          <textarea placeholder="Enter review comments . . ." rows="3" class="form-control" style="border: 1px solid #6FB3E0; background: white;padding-left:5px ;"></textarea>
        </div>-->
        <div>
          <label style="margin-top:10px">Service charge (Rs.)</label>
          <input type="number" [(ngModel)]="doctorVerificationPending[0].opd.forusShare" (keyup)="verifyPercentageDeduction(doctorVerificationPending[0].opd.forusShare)" class="form-control" min="0" placeholder="Enter service charge" style="background: white;" onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
        </div>
        <br>
        <div class="text-center">
        <button class="btn btn-sm btn-warning" style="margin-left: 5px;margin-right: 5xp;" (click)="reviewLater()"><i class="fa fa-clock-o"></i>&nbsp;Review Later</button>
        <button class="btn  btn-sm btn-success" style="margin-left: 5px;margin-right: 5xp;" (click)="updateDoctorStatusById(doctorVerificationPending[0].userId,true,'APPROVED',doctorVerificationPending[0].opd.forusShare,false)"><i class="fa fa-check-circle"></i>&nbsp;Approve</button>
        <button class="btn  btn-sm btn-danger" style="margin-left: 5px;margin-right: 5xp;" (click)="updateDoctorStatusById(doctorVerificationPending[0].userId,false,'REJECTED',doctorVerificationPending[0].opd.forusShare,false)"><i class="fa fa-times-circle"></i>&nbsp;Reject</button>
        </div>
      </td></tr>

    </tfoot>
  </table>
</div>
</div>
<!-- end : doctor verification page-->
<!-- start : all doctors page-->
<div *ngIf="selectedTab=='allDoctorsTop'">
<div class="col-xs-12 table-responsive " style="margin-top: 2%;">
  <table class="table table-striped panel" style="border-radius: 0px;">
    <tr>
      <th >#</th>
      <th >Name</th>
      <th >Email</th>
      <th >Mobile</th>
      <th style="width: 10px;">Consultation Fee</th>
      <th >Verification Status</th>
      <th >De-activate/Activate</th>
      <th style="border-left:1px solid lightgray">Service Charge (Rs.)</th>
    </tr>
    <tr>
      <td class="primeng-table-search" style="padding:0px !important"></td>
      <td class="primeng-table-search" style="padding:0px !important"></td>
      <td class="primeng-table-search" style="padding:0px !important"><input type="text" style="border-bottom:0px solid #e1e1e1;padding-left: 5px;" class="form-control" [(ngModel)]="searchDoctorByEmail" placeholder="Search by email" (keyup)="filterDoctor(searchDoctorByEmail,searchDoctorByMobile)"></td>
      <td class="primeng-table-search" style="padding:0px !important"><input type="text" style="border-bottom:0px solid #e1e1e1;padding-left: 5px;" class="form-control" [(ngModel)]="searchDoctorByMobile" placeholder="Search by mobile" (keyup)="filterDoctor(searchDoctorByEmail,searchDoctorByMobile)"></td>
      <td class="primeng-table-search" style="padding:0px !important"></td>
      <td class="primeng-table-search" style="padding:0px !important"></td>
      <td class="primeng-table-search" style="padding:0px !important"></td>
      <td class="primeng-table-search" style="padding:0px !important"></td>
    </tr>
    <tr *ngIf="showAllDoctors==null || showAllDoctors.length==0" class="text-center"><td colspan="8">No record(s) found</td></tr>
    <tr *ngFor="let doctor of showAllDoctors | paginate: { itemsPerPage: 8, currentPage: p }; let i=index;"  style="cursor: pointer;">
      <td (click)="showDoctorDetailsPopUp(doctor)">{{p==null||p=='undefined'?i+1:i+1+(8*(p-1))}}</td>
      <td (click)="showDoctorDetailsPopUp(doctor)">{{doctor.firstName}}&nbsp;{{doctor.lastName}}</td>
      <td (click)="showDoctorDetailsPopUp(doctor)">{{doctor.email != null ? doctor.email : 'NA'}}</td>
      <td (click)="showDoctorDetailsPopUp(doctor)">{{doctor.mobileNumber != null ? doctor.mobileNumber : 'NA'}}</td>
      <td (click)="showDoctorDetailsPopUp(doctor)">{{doctor.opd !=null?(doctor.opd.fee!=null ? doctor.opd.fee: 'NA'):'NA'}}</td>
      <td (click)="showDoctorDetailsPopUp(doctor)" *ngIf="doctor.isVerified == 'APPROVED'">Approved</td>
      <td (click)="showDoctorDetailsPopUp(doctor)" *ngIf="doctor.isVerified == 'REJECTED'">Rejected</td>
      <td (click)="showDoctorDetailsPopUp(doctor)" *ngIf="doctor.isVerified == 'NOT_VERIFIED'">Verification Pending</td>
      <td><p-inputSwitch *ngIf="doctor.isVerified == 'APPROVED'" [(ngModel)]="doctor.isActive" (onChange)="updateDoctorStatusById(doctor.userId,doctor.isActive,doctor.isVerified,null,true)">
      </p-inputSwitch>
      </td>
      <td style="border-left:1px solid lightgray" ><input type="number" min="0" *ngIf="doctor.isVerified != 'NOT_VERIFIED'" class="form-control" [(ngModel)]="doctor.opd.forusShare"style="width:100px;float:left" onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);"><button *ngIf="doctor.isVerified != 'NOT_VERIFIED'" class="btn btn-primary btn-xs" style="margin-left: 10px;" (click)="updateDoctorStatusById(doctor.userId,doctor.isActive,doctor.isVerified,doctor.opd.forusShare,true)">Update</button></td>
    </tr>
    <tfoot>
      <tr>
          <td colspan="8" class="text-center">
          <!--<td colspan="7" class="text-center">-->
          <pagination-controls (pageChange)="p = $event" *ngIf="showAllDoctors!=null && showAllDoctors.length>0"></pagination-controls>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
</div>
<!-- end : all doctor page-->
<!-- start : invoice page-->
<div *ngIf="selectedTab=='paymentDashboardTop'">
<!-- start : filter selection -->
<!--<div class="tile-progress bg-white text-left">
  <span style="text-align: left;">Invoice Generation</span>
  <div class="row">
    <div class="col-xs-12 col-lg-2">
      <label style="margin-top:10px">Select Start Date</label>   	
      <input type="date" class="form-control" [(ngModel)]="invoiceStartDate" id = "invoiceStartDate" autocomplete="off">
      
    </div>
    <div class="col-xs-12 col-lg-2">
      <label style="margin-top:10px">Select End Date</label>
      <input type="date" class="form-control" [(ngModel)]="invoiceEndDate" id = "invoiceEndDate" autocomplete="off">
    </div>
    <div class="col-xs-12 col-lg-3">
      <label style="margin-top:10px">Select Doctor</label>
      <ng-select [items]="telecaredoctors" name="telecaredoctors" bindLabel="firstName"
      [clearable]="true" [searchable]="true" bindValue="userId" (change)="fetchPercentageDeduction(doctorId_invoice);fetchInvoices()" [(ngModel)]="doctorId_invoice" placeholder="Select doctor">
     </ng-select>
    </div>
    <div class="col-xs-12 col-lg-2">
      <label style="margin-top:10px">Service Charge</label>
      <input type="number" [(ngModel)]="percentageDeduction" readonly (keyup)="verifyPercentageDeduction()" class="form-control" min="0" placeholder="Enter forus share (in %)">
    </div>
    <div class="col-xs-6 col-lg-2 text-right">
      <button class="btn btn-primary" (click)="generateInvoice()" style="margin-top: 36px;">Generate Invoice</button>
    </div>
  </div>
</div>-->
<!-- end : filter selection -->
<!-- start : show all invoices-->
<!--<div class="col-xs-12 bg-white table-responsive">
<table class="table table-striped table-borderless">
  <tr>
    <th>#</th>
    <th>Invoice Number</th>
    <th>Start Date</th>
    <th>End Date</th>
    <th>Total Cost</th>
    <th>Service Charge</th>
    <th></th>
  </tr>
  <tr>
    <td *ngIf="invoices == null || invoices.length==0" colspan="6" class="text-center"> No record(s) found</td>
  </tr>
  <tr *ngFor= "let invoice of invoices; let i=index;">
    <td>{{i+1}}</td>
    <td>{{invoice.invoiceNumber}}</td>
    <td>{{invoice.startDate}}</td>
    <td>{{invoice.endDate}}</td>
    <td>{{invoice.amount}}</td>
    <td>{{invoice.forusServiceCharge}}</td>
    <td><button class="btn btn-sm btn-primary" (click)="downloadBase64FileByUrlAndName(invoice.invoiceBlobUrl,'Invoice_'+invoice.startDate+'_'+invoice.endDate+'.pdf')">Download Invoice</button></td>
  </tr>
</table>
</div>-->
<div class="col-xs-12 bg-white">
<div class="col-xs-3">
<label style="margin-top:10px">Start Date</label><br>
<input type="date" [(ngModel)]="invoiceStartDate" class="form-control">
</div>
<div class="col-xs-3">
  <label style="margin-top:10px">End Date</label><br>
  <input type="date" [(ngModel)]="invoiceEndDate" class="form-control">
</div>
<div class="col-xs-3">
  <label style="margin-top:10px">Select Doctor</label>
  <ng-select [items]="telecaredoctors" name="telecaredoctors" bindLabel="firstName"
  [clearable]="true" [searchable]="true" bindValue="userId" [(ngModel)]="doctorId_invoice" placeholder="Select doctor">
 </ng-select>
</div>
<div class="col-xs-3">
  <label style="margin-top:10px">&nbsp;</label><br>
  <button class="btn btn-primary" (click)="exportInvoiceExcel(invoiceStartDate,invoiceEndDate,doctorId_invoice)">Export</button>
</div>
</div>
</div>
<!-- end : invoice page-->

<!-- end : end all invoices-->

<!-- start : iframe-->
<iframe src="" style="display: none;" id="iframe"></iframe>
<!-- start : iframe-->
<!-- start : doctor document popup -->
<div class="modal fade" id="doctorDocumentPreviewPopUp">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header"></div>
      <div class="modal-body" id="doctorDocumentPreviewBody" style="height: 500px;">
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" (click)="hideDoctorDocumentPreviewPopUp()">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- end : doctor document popup -->
<!-- start : doctor details popup -->
<div class="modal fade" id="doctorDetailsPopUp">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header text-center"> Doctor Bank Details</div>
      <div class="modal-body" id="doctorDetailsBody">
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" (click)="hideDoctorDetailsPopUp()">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- end : doctor details popup -->
<!-- start : deactivate doctor popup -->
<div class="modal fade" id="deactivateDoctorPopUp">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header text-center"> Doctor can not be de-activated</div>
      <div class="modal-body">
        <p style="margin-top:10px"> This doctor has appointments booked till <span style="font-weight: bold;">{{pendingAppointmentDate}}</span> .</p>
        <p style="margin-top:10px"> De-activation can be performed only after <span style="font-weight: bold;">{{pendingAppointmentDate}}</span> for this doctor</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" (click)="hideDeactivateDoctorPopUp()">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- end : deactivate doctor popup -->


